module.exports = __webpack_public_path__ + "static/media/arrow-up-wh.3af49567.svg";